"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCssVariablesForColor = createCssVariablesForColor;
exports.parseColorFromCssBorder = parseColorFromCssBorder;
const color_1 = __importDefault(require("color"));
const log_1 = require("@aurora/shared-utils/log");
const SafeColor_1 = __importDefault(require("./SafeColor"));
const log = (0, log_1.getLog)(module);
/**
 * Creates a map where the keys are CSS variables and the values are the expanded parts of
 * a valid HSL color.
 *
 * @param color the color
 * @param varPrefix the CSS var prefix.
 *
 * @author Adam Ayres
 */
function createCssVariablesForColor(color, varPrefix) {
    if (color == null) {
        return {};
    }
    if (color === null || color === void 0 ? void 0 : color.startsWith('var(')) {
        return {
            [varPrefix]: color
        };
    }
    let colorObject;
    try {
        colorObject = (0, color_1.default)(color);
    }
    catch (_a) {
        log.error(`Unable to create CSS variables for color ${color}`);
        return null;
    }
    const [h, s, l, a] = colorObject.hsl().array();
    const hVar = `${varPrefix}-h`;
    const sVar = `${varPrefix}-s`;
    const lVar = `${varPrefix}-l`;
    const mapping = {
        [hVar]: h.toString(),
        [sVar]: `${s}%`,
        [lVar]: `${l}%`
    };
    if (a) {
        const aVar = `${varPrefix}-a`;
        return Object.assign(Object.assign({}, mapping), { [aVar]: a.toString(), [varPrefix]: `hsla(var(${hVar}), var(${sVar}), var(${lVar}), var(${aVar}))` });
    }
    else {
        return Object.assign(Object.assign({}, mapping), { [varPrefix]: `hsl(var(${hVar}), var(${sVar}), var(${lVar}))` });
    }
}
/**
 * Attempts to parse the color from the specified border color.
 *
 * @param border the border color
 * @param fallback fallback used when color cannot be determined
 * @param validColorCheck callback function to check if the color is valid
 */
function parseColorFromCssBorder(border, fallback = 'transparent', validColorCheck = (color) => (0, SafeColor_1.default)({}, color, null) !== null) {
    var _a;
    const items = (_a = border === null || border === void 0 ? void 0 : border.split(/(?!\(.*)\s(?![^(]*?\))/g)) !== null && _a !== void 0 ? _a : [];
    const firstParen = items.findIndex(item => item.includes('('));
    const parsedValue = items.slice(firstParen).join(' ');
    const validColor = validColorCheck(parsedValue);
    if (validColor) {
        return parsedValue;
    }
    return fallback;
}
//# sourceMappingURL=ColorHelper.js.map